import { gql } from '@apollo/client';

export default gql`
  mutation createBulkVouchers($serviceNumber: String!, $travelDate: String!, $compensationPercentage: Int!) {
    createBulkVouchers(serviceNumber: $serviceNumber, travelDate: $travelDate, compensationPercentage: $compensationPercentage)
  }
`;
